import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconShare = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="darkPurple">
      <Path d="M1 11.988a3.87 3.87 0 0 0 6.507 2.847l5.766 2.603c-.04.216-.062.434-.066.654a3.896 3.896 0 1 0 .689-2.2l-5.418-2.445c.385-.93.387-1.973.005-2.904l5.41-2.458a3.879 3.879 0 1 0-.689-2.2c.004.22.026.438.067.654L7.52 9.153A3.87 3.87 0 0 0 1 11.988Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
